import webSDK from './web.sdk';

const cohortSDK = ({
  handleRelativeRedirection,
  goBack,
  previousUrl = '',
  redirectUrl = '',
}: {
  handleRelativeRedirection?: (route: string, selectedExamClass: any) => void;
  goBack?: () => void;
  previousUrl?: string;
  redirectUrl?: string;
}) => {
  console.log("cohortSDK called");
  console.log("window object:", window);
  console.log("window.initPWAuthWebSDK:", window?.initPWAuthWebSDK);

  if (window?.initPWAuthWebSDK) {
    console.log("initPWAuthWebSDK is available, proceeding...");
    const user = JSON.parse(localStorage.getItem("user") || "{}")
    const propConfig = {
      flow: 'cohort',
      webSDK,
      renderType: 'page',
      handleRelativeRedirection,
      goBack,
      details: {
        redirectUrl,
        userId: "6852b3b7c4bc6bb9632144c5",
        previousCohortId: "669a0fa362d7afcfa254dc74",
        previousUrl,
      },
    };
    window?.initPWAuthWebSDK(propConfig);
  }
};
export default cohortSDK;
